import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import InputText from "@/Components/InputText.vue";
import Button from "primevue/button";
import useVuelidate from "@vuelidate/core";
import { required } from "@/i18n-validators";
import { useForm } from "@inertiajs/inertia-vue3";
import { useSpinner } from "../../../Plugins/spinner";
import WeatherStationService from "@/Services/WeatherStationService";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    props: {
        modelValue: {
            type: Object,
            default: {},
        },
    },
    emits: ["cancel", "saved"],
    setup(__props, { expose, emit: emits }) {
        expose();
        const props = __props;
        const spinner = useSpinner();
        const weatherStationService = new WeatherStationService();
        const value = ref(props.modelValue);
        const form = useForm({
            code: value.value.code,
            place: value.value.place,
            city: value.value.city,
            postal_code: value.value.postal_code,
            state: value.value.state,
            country: value.value.country,
            latitude: value.value.latitude,
            longitude: value.value.longitude,
            altitude: value.value.altitude,
        });
        const rules = {
            code: { required },
            place: { required },
            city: { required },
            postal_code: { required },
            state: { required },
            country: { required },
            latitude: { required },
            longitude: { required },
            altitude: { required },
        };
        const v$ = useVuelidate(rules, form);
        const submitted = ref(false);
        const submit = async () => {
            submitted.value = true;
            const isFormValid = await v$.value.$validate();
            if (!isFormValid) {
                return;
            }
            spinner.show();
            if (value.value.id) {
                weatherStationService.update(value.value.id, form.data())
                    .then((result) => {
                    emits("saved", result.data.data);
                })
                    .finally(() => spinner.hide());
            }
            else {
                weatherStationService.store(form.data())
                    .then((result) => {
                    emits("saved", result.data.data);
                })
                    .finally(() => spinner.hide());
            }
        };
        const __returned__ = { spinner, weatherStationService, props, emits, value, form, rules, v$, submitted, submit, InputText, get Button() { return Button; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
